export const ChannelType = {
  MERCHANT_PORTAL: 'MERCHANT_PORTAL',
  MERCHANT_API: 'MERCHANT_API',
  CHECKOUT_POS: 'CHECKOUT_POS',
  ECOMMERCE: 'ECOMMERCE',
  ONLINE_APPLICATIONS: 'ONLINE_APPLICATIONS',
}

export const ChannelTypesForSelectBox = [
  {
    key: ChannelType.MERCHANT_PORTAL,
    value: ChannelType.MERCHANT_PORTAL,
    valueLabel: 'Merchant Portal',
  },
  {
    key: ChannelType.MERCHANT_API,
    value: ChannelType.MERCHANT_API,
    valueLabel: 'Merchant API',
  },
  {
    key: ChannelType.CHECKOUT_POS,
    value: ChannelType.CHECKOUT_POS,
    valueLabel: 'Checkout Pos',
  },
  {
    key: ChannelType.ECOMMERCE,
    value: ChannelType.ECOMMERCE,
    valueLabel: 'Ecommerce',
  },
  {
    key: ChannelType.ONLINE_APPLICATIONS,
    value: ChannelType.ONLINE_APPLICATIONS,
    valueLabel: 'Online Applications',
  },
]
